export type ScopeGroupable = {
  groupName?: string | null
  referencePath?: string | null
}

// root/01-edu_ai-module/ -> 01-edu_ai-module
export const referenceSegment = (referencePath: string) =>
  referencePath.split('/').filter(Boolean).at(-1)

// referencePath groups (two references named "Module" can be different
// content); groupName only labels, so groups may share a name.
export const groupScopes = <T extends ScopeGroupable>(scopes: T[]) =>
  [...Map.groupBy(scopes, (s) => s.referencePath ?? s.groupName ?? 'Other')]
    .map(([key, scopes]) => ({
      key,
      name: scopes[0].groupName ?? 'Other',
      referencePath: scopes[0].referencePath ?? undefined,
      scopes,
    }))
    .sort(
      (a, b) =>
        b.scopes.length - a.scopes.length || a.name.localeCompare(b.name),
    )
